import React, {useContext, useState, useLayoutEffect} from "react";
import Cercle from 'components/Cercle';
import Logo from 'components/Logo';
import TitreAnime from 'components/TitreAnime';
import { SettingsContext } from 'Providers/SettingsProvider';
import './Mentions.scss'
import Utils from 'utils/Utils';

function InnerMentions({mentions}) {
  const [ loaded, setLoaded ] = useState(false);
  const { translate } = useContext(SettingsContext);
  useLayoutEffect(()=>{
    const timer=setTimeout(()=>setLoaded(true),100);
    return ()=>clearTimeout(timer);
  },[setLoaded]);
  return <div className={'mentions'+(loaded ? ' loaded':'')}>
    <div className='main-header'>
      <Cercle color={true}/>
      <Logo/>
    </div>
    <div className="mentions-body">
        <div className="titre">
          <TitreAnime titre={translate(mentions,'titre')}/>
        </div>
        <div className="texte">
          {Utils.parseWithLinks(translate(mentions,'texte'))}
        </div>
    </div>
    <div className="spacer"></div>
  </div>;
}
export default InnerMentions;
